import { action, observable } from "mobx";
import localStorage from "local-storage";
import Guest from "~/models/Guest";
import GuestRepository from "~/repository/GuestRepository";
import SupportRepository from "~/repository/SupportRepository";
import NestStore from "./NestStore";

class GuestStore extends NestStore {
  /**
   * @property {Guest}
   */
  @observable guest;

  /**
   * @property {Array}
   */
  @observable countryOptions = [];

  /**
   * @property {Array}
   */
  @observable regionOptions = [];

  rootStore = null;

  constructor(rootStore) {
    super();

    this.rootStore = rootStore;

    this.guest = new Guest({ address: { country: "USA" } });

    this.guestRepository = new GuestRepository();
    this.supportRepository = new SupportRepository();
  }

  @action
  load() {
    this.isLoading = true;

    return Promise.all([this.getCountries(), this.getRegions()]).then(() => {
      this.isLoading = false;
    });
  }

  @action
  getCountries() {
    return this.supportRepository.getCountries().then(response => {
      const countries = response;

      this.countryOptions = [];

      countries.forEach(country => {
        this.countryOptions.push({ key: country, text: country, value: country });
      });
    });
  }

  @action
  getRegions() {
    return this.supportRepository.getCountryRegions(this.guest.address.country).then(response => {
      const regions = response;

      this.regionOptions = [];

      const keys = Object.keys(regions);

      keys.forEach(key => {
        this.regionOptions.push({ key, text: regions[key], value: key });
      });
    });
  }

  @action
  validate() {
    this.isLoading = true;
    this.clearErrorMessages();

    localStorage.set("guest", this.guest);

    return this.guestRepository
      .validate("create", {
        email: this.guest.email,
        address: {
          street: this.guest.address.street,
          street2: this.guest.address.street2,
          city: this.guest.address.city,
          state: this.guest.address.state,
          zip: this.guest.address.zip,
          country: this.guest.address.country,
        },
        firstName: this.guest.firstName,
        lastName: this.guest.lastName,
        contactPhone: this.guest.contactPhone,
      })
      .catch(error => {
        this.setErrorMessages(error);

        throw error;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  @action
  setGuestData(data) {
    this.guest.setData(data);
  }
}

export default GuestStore;
